import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';
import { locationSchema } from '../../location.deployParam';
import { ProcessDataElementKindEnum } from '../../../../../db';

export const processCollectNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('processCollect'),
    controlValues: z.object({
        location: locationSchema,
        processId: z.string().uuid(),
        useStandardizedOutputs: z.object({
            status: z.boolean().default(true),
            // specId: z.boolean().default(true),
            badCount: z.boolean().default(true),
            // specName: z.boolean().default(true),
            goodCount: z.boolean().default(true),
            // requiredCount: z.boolean().default(true),
            validationError: z.boolean().default(true),
        }),
        dataElements: z.array(z.object({
            name: z.string(),
            id: z.string().uuid(),
            // sourceVarId: z.string(),
            // collectionKind: z.enum([ ProcessDataElementCollectionKindEnum.Collect, ProcessDataElementCollectionKindEnum.SpecParam ]),
            type: z.enum([ ProcessDataElementKindEnum.String, ProcessDataElementKindEnum.Number, ProcessDataElementKindEnum.Boolean, ProcessDataElementKindEnum.Material ]),
        })),
    }),
});
export interface ProcessCollectNodeCfgSchema extends z.infer<typeof processCollectNodeCfgSchema> {}

export const processCollectNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({
            collect: 'event',
        }),
        outputs: () => ({
            badCollect: 'event',
            goodCollect: 'event',
        }),
    },
    dataSockets: {
        inputs: (cfg: NodeCfg<'processCollect'>): Record<'materialId' | `de_${string}`, 'string' | 'number' | 'boolean'> => {
            const ret: Record<'materialId' | `de_${string}`, 'string' | 'number' | 'boolean'> = {
                materialId: 'string',
            };
            for (const de of cfg.controlValues.dataElements) {
                if (de.type === ProcessDataElementKindEnum.String || de.type === ProcessDataElementKindEnum.Material) {
                    // FUTURE: if we add more types like uuid or even more specific material uuid then we can handle that here
                    ret[`de_${de.id}`] = 'string';
                } else if (de.type === ProcessDataElementKindEnum.Number) {
                    ret[`de_${de.id}`] = 'number';
                } else if (de.type === ProcessDataElementKindEnum.Boolean) {
                    ret[`de_${de.id}`] = 'boolean';
                }
            }
            return ret;
        },
        outputs: (cfg: NodeCfg<'processCollect'>): Record<`output_${string}`, 'string' | 'number' | 'boolean'> => {
            const ret: Record<`output_${string}`, 'string' | 'number' | 'boolean'> = {};
            if (cfg.controlValues.useStandardizedOutputs.status) {
                ret.output_status = 'string';
            }
            // if (cfg.controlValues.useStandardizedOutputs.specId) {
            //     ret.output_specId = 'string';
            // }
            if (cfg.controlValues.useStandardizedOutputs.badCount) {
                ret.output_badCount = 'number';
            }
            // if (cfg.controlValues.useStandardizedOutputs.specName) {
            //     ret.output_specName = 'string';
            // }
            if (cfg.controlValues.useStandardizedOutputs.goodCount) {
                ret.output_goodCount = 'number';
            }
            // if (cfg.controlValues.useStandardizedOutputs.requiredCount) {
            //     ret.output_requiredCount = 'number';
            // }
            if (cfg.controlValues.useStandardizedOutputs.validationError) {
                ret.output_validationError = 'string';
            }
            return ret;
        },
        
    },
} satisfies NodeSocketCfg<ProcessCollectNodeCfgSchema>;
